import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";



const LandingCardComponent = ({ title, actions, children, hasContentBg }) => {
  return (
    <Card
      sx={{
        width: "100%",
        minWidth: 300,
        minHeight: 150,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        //justifyContent: "center",
        justifyContent: "flex-start",
        alignItems: "center",
        textAlign: "center",
        cursor: "pointer",
        boxShadow: "0 0 10px #ccc",
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      }}
    >
      {(actions || title) && (
        <CardHeader
          title={title}
          action={actions}
          sx={{
            width: "100%",
            textAlign: "center",
            ".MuiCardHeader-content .MuiTypography-root": {
              fontSize: "1rem",
              fontWeight: "bold",
            },
          }}
        />
      )}
      {children && (
        <CardContent
          sx={{
            width: "100%",
            textAlign: "center",
            ...(hasContentBg ? { backgroundColor: "#FAFAFA" } : { pt: 0 }),
          }}
        >
          {children}
        </CardContent>
      )}
    </Card>
  );
};

export default LandingCardComponent;
